import React, { Component } from 'react';
import { SelectGroupStyle, TableStyle } from '../PlayerList/PlayerListStyle';
import { ContainerStyle, FiltersArea, ClubName } from './ProLeagueCalendarStyle';
import Select from '../UI/Select/Select';
import Link from '../UI/Link/Link';
import { Match } from '../../types';
import { Redirect } from "react-router-dom";
import moment from 'moment';
import lockr from 'lockr';
import { groupBy, matches, uniqBy } from 'lodash';
import Button from '../UI/Button/Button';
import Icon from 'antd/lib/icon';
import { Title, TitleType } from '..';
import { BoatSvg } from '../../styles/custom-icons';

const BoatIcon = (props: any) => <Icon component={BoatSvg} {...props} />;

export interface CalendarProps {
	data: any[];
	size: number;
	isLoading?: boolean;
	showMonthsFilter?: boolean;
	assetsCdn?: string;
	weekId: number;
	showHeader?: boolean;
	t: any;
}

export interface CalendarState {
	navigateToMatchId: any,
	weekId: number,
	filters: any,
	filtersActivated: boolean
}

class Calendar extends Component<CalendarProps, CalendarState> {

	constructor(props: CalendarProps) {
		super(props);

		this.state = {
			filters: {
				month: -1
			},
			filtersActivated: true,
			navigateToMatchId: null,
			weekId: props.weekId
		};
	}

	componentDidUpdate(prevProps: CalendarProps) {
		if (this.props.weekId !== prevProps.weekId) {
			this.setState({ weekId: this.props.weekId });
		}
	}


	onFilterChange = (name: string, value: string | number) => {
		const filters: any = Object.assign({}, this.state.filters, { [name]: value });
		this.setState({ filters })
	};

	matchFilter = (match: Match, filters: any) => {
		let show = true;
		if (filters.month !== -1 && filters.month !== moment(match.date).month()) {
			show = false;
		}

		return show;
	};

	enableFilters = (e: any) => {
		this.setState({ filtersActivated: true });
	};

	onCalendarWeekChanged = (weekId: number) => {
		this.setState({ weekId });
	};

	render() {
		const { data, size, showHeader, isLoading, showMonthsFilter, assetsCdn, t } = this.props;
		const { navigateToMatchId, weekId, filtersActivated } = this.state;
		const locale: any = lockr.get('locale') || 'nl';

		moment.locale(locale);

		const visibleWeekMatches = data && data.filter((match: Match) => match.weekId === weekId) || [];

		const matchesList = visibleWeekMatches
			.filter(match => this.matchFilter(match, this.state.filters));

		const groupByDays = groupBy(matchesList, match => moment(match.date).format('YYYY-MM-DD'));
		const matchWeekIds = uniqBy(data, match => match.weekId)
			.map(match => ({ id: match.weekId, name: `${t('general.footballWeek')} ${match.weekId}` }))
			.sort((firstWeek: any, secondWeek: any) => firstWeek.id - secondWeek.id);

		const selectedWeekId = matchWeekIds.find((item: any) => item.id === weekId);

		const months = [
			{ id: -1, name: 'Alle maanden' },
			{ id: 0, name: 'Januari' },
			{ id: 1, name: 'Februari' },
			{ id: 2, name: 'Maart' },
			{ id: 3, name: 'April' },
			{ id: 4, name: 'Mei' },
			{ id: 5, name: 'Juni' },
			{ id: 6, name: 'Juli' },
			{ id: 7, name: 'Augustus' },
			{ id: 8, name: 'September' },
			{ id: 9, name: 'Oktober' },
			{ id: 10, name: 'November' },
			{ id: 11, name: 'December' },
		];

		const columns = [
			{
				title: 'Home',
				key: 'homeId',
				dataIndex: 'homeId',
				width: '40%',
				render: (homeId: any, record: any) => {
					const clubBadge = `${assetsCdn}/badges/club_${homeId.id}.png`;

					return <React.Fragment>
						<ClubName className="team-name" fullName={record.homeId.name} shortName={record.homeId.short}></ClubName>
					</React.Fragment>;
				}
			},
			{
				title: 'Rit',
				key: 'feedUrl',
				dataIndex: 'feedUrl',
				width: '20%',
				render: (text: string, record: any) => {
					const matchDate = moment(record.date);
					const matchNotStarted = moment().isBefore(matchDate);
					return <div style={{ backgroundColor: "#54595F", color: 'white' }}><b className={`score ${matchNotStarted ? 'scheduled' : 'started'}`}>
						{matchNotStarted ? moment(record.date).format('DD/MM HH:mm') : `${record.homeScore}-${record.awayScore}`}
					</b></div>;
				}
			}, {
				title: 'Away',
				key: 'awayId',
				dataIndex: 'awayId',
				width: '40%',
				render: (awayId: any, record: any) => {
					const clubBadge = `${assetsCdn}/badges/club_${awayId.id}.png`;
					return <React.Fragment>
						<ClubName className="team-name" fullName={record.awayId.name} shortName={record.awayId.short}></ClubName>
					</React.Fragment>;
				}
			},
		];

		const tableEventHandler = (match: any) => ({
			onClick: (event: any) => {
				const matchDate = moment(match.date);
				if (moment().isAfter(matchDate)) {
					this.setState({ navigateToMatchId: match.id });
				}
			},
		});

		return (
			<ContainerStyle>
				{navigateToMatchId && <Redirect
					to={{ pathname: `/match/${navigateToMatchId}` }}
				/>}
				{
					(showMonthsFilter &&
						<SelectGroupStyle>
							{(<Select
								block
								keyProperty={'id'}
								textProperty={'name'}
								onSelect={(value: any) => this.onFilterChange('month', value)}
								values={months}
								placeholder={months[0].name}
							/>) || null}
						</SelectGroupStyle>
					) || null
				}


				<FiltersArea>
					{
						!filtersActivated ?
							<Button
								type="primary"
								onClick={this.enableFilters}
								size="default">
								Filter
								<Icon type="right" />
							</Button>
							: null
					}

					{
						filtersActivated && selectedWeekId && selectedWeekId.id ?
							<Select
								block
								keyProperty={'id'}
								textProperty={'name'}
								onSelect={(value: any) => this.onCalendarWeekChanged(value)}
								value={selectedWeekId.id}
								values={matchWeekIds}
							/>
							: null
					}
				</FiltersArea>

				<div className="c-match-collection">

					{matchesList.map((match, index) => {

						const matchDate = moment(match.date);
						const matchNotStarted = moment().isBefore(matchDate);
						return <div className="c-match" key={match.id}>
							<div style={{ margin: "0px 10px 0px 10px" }}>
								<h4 style={{ color: '#151820 !important', marginBottom: "-10px" }} className="c-match-collection__subtitle">{moment(matchDate).format('DD')}</h4>
								<span style={{ backgroundColor: "#f1f1f1", color: "#151820", borderRadius: "50px", padding: "2px 8px 2px 8px" }}>{moment(matchDate).format('MMM').toUpperCase()}</span>
							</div>
							<div className="c-match__team">
								<a style={{ color: '#151820 !important', fontSize: '16px', fontWeight: 600 }} className="c-link c-card__link--neutral" href={`/match/${match.id}`}>{match.homeId.name}</a>
								<a style={{ color: '#151820' }} className="c-match__link" href={`/match/${match.id}`}><span>{match.postponed ? t('general.postponed') : matchNotStarted ? moment(match.date).format('HH:mm') : `${match.homeScore}-${match.awayScore}`}</span></a>
							</div>
							<div style={{ alignItems: "right" }}>
								<BoatIcon style={{ paddingRight: "20px" }} />
							</div>
							{/* <div className="c-match__footer"><a href="https://standard.tickethour.be/showProductList.html" className="c-link-arrow c-link-arrow--sm">Meer info </a></div> */}
						</div>
					})}

				</div>
			</ContainerStyle>
		);
	}
}

export default Calendar;
